/**
 * Created by dx.yang on 2017/2/15.
 */

import * as constants from './constants';

//region前5个顺序固定，其他自然排序
// let regionSortIndex = [
//     'cn-beijing-6',
//     'cn-shanghai-2',
//     'cn-hongkong-2',
//     'cn-beijing-1-new',
//     // 'ap-singapore-1'
// ];
// let getRegionIdx = regionCode => {
//     let idx = regionSortIndex.indexOf(regionCode);
//     if (idx === -1) {
//         idx = 999;
//     }
//     return idx;
// }

export default {
    [constants.regionList](state, data) {
        data = data || [];
        // console.log(data);
        // data.sort((a, b) => {
        //     return getRegionIdx(a.regionCode) - getRegionIdx(b.regionCode);
        // });
        state.regionList = data;
    },
    [constants.initMenuRegion](state, data) {
        if(MENU_REGION_ITEM !== undefined){
            MENU_REGION_ITEM.remove();
        }
        var areaSort = ['cn', 'ap', 'eu'];
        let list = data.regionList.filter((item) => {
            return areaSort.includes(item.regionCode.split('-')[0]);
        }); 
        let regionKey = data.regionKey;
        if(list.length > 0 && _.find(list, {regionCode: regionKey}) === undefined) regionKey = list[0].regionCode;
        if(document.querySelectorAll(".header-regions").length > 0){
            MENU_REGION_ITEM = __ksStorage__.initRegion(list, regionKey);
            __ksStorage__.on('region',(key) => {
                if(key) state.regionKey = key;
            });
        }
        setTimeout(() => {
            if(document.querySelectorAll(".header-regions").length > 0 && MENU_REGION_ITEM === undefined){
                MENU_REGION_ITEM = __ksStorage__.initRegion(list, regionKey);
                __ksStorage__.on('region',(key) => {
                    if(key) state.regionKey = key;
                });
            }
        }, 1000);
    },
    [constants.RegionInfos](state, data) {
        state.regionInfos = data || [];
    },
    [constants.checkVncPermission](state, data) {
        state.vncPermission = data;
    },
    //layout里面commit的region信息
    [constants.unifiedRegion](state, data) {
        state.regionKey = data.regionKey;
        state.regionInfo = data.regionInfo;
    },
    // --以下为未登录mutations--
    [constants.noLoginRegionList](state, data) {
        data = data || [];
        // console.log(data);
        // data.sort((a, b) => {
        //     return getRegionIdx(a.regionCode) - getRegionIdx(b.regionCode);
        // });
        state.regionList = data;
    },
    [constants.vncPermissionRegion](state, data) {
        state.vncPermissionRegion = data;
    },
    //--以上为未登录mutations--
    [constants.changeSupportEbsIframe](state, data) {
        state.supportEbsIframe = data
    },
};
